import React from 'react';
import { Link } from 'react-scroll';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="logo-container">
          <p>Tales Inc.</p>
          <img src="/yorozu-logo.png" alt="買取よろず" className="yorozu-logo" />
        </div>
        <nav>
          <ul>
            <li><Link to="philosophy" smooth={true} duration={500}>PHILOSOPHY</Link></li>
            <li><Link to="business" smooth={true} duration={500}>SERVICE</Link></li>
            <li><Link to="news" smooth={true} duration={500}>NEWS</Link></li>
            <li><Link to="contact" smooth={true} duration={500}>CONTACT</Link></li>
            <li><Link to="company-overview" smooth={true} duration={500}>COMPANY</Link></li>
          </ul>
        </nav>
      </header>

      <main>
        <section className="top-image">
          <div className="main-copy">
            <h1>価値を繋ぐ、世界へ届ける。<br />新たな循環を創り続ける会社へ</h1>
          </div>
        </section>
        <section id="philosophy">
          <h2>PHILOSOPHY</h2>
          <h3 className="section-title">企業理念</h3>
          <p>日本の商品価値を世界に伝える</p>
        </section>
        <section id="business">
          <h2>SERVICE</h2>
          <h3 className="section-title">事業紹介</h3>
          <div className="content">
            <div className="item brand-reuse">
              <img src="/yorozu-logo.png" alt="買取よろず" className="yorozu-business-logo" />
              <p><strong>ブランドリユース業（買取・販売）</strong><br />
東京と大阪でブランド品・貴金属の買取と販売事業を展開。<br />
買取よろず開業。</p>
            </div>
            <div className="item">
              <img src="/business1.jpg" alt="事業1" />
              <p><strong>輸出業</strong><br />
国産ホビーを中心とした製品を国外に販売しております。<br />
<strong>【取引地域】</strong><br />
北米・東アジア・東南アジア・イギリス・EU諸国<br />
南米一部地域（チリ、ペルー）</p>
            </div>
            <div className="item">
              <img src="/business2.jpg" alt="事業2" />
              <p><strong>卸小売業</strong><br />フィギュア、カードゲーム、プラモデルといった国産ホビー製品を中心としたEC小売、卸売を行っております。</p>
            </div>
            <div className="item">
              <img src="/business3.jpg" alt="事業3" />
              <p><strong>営業代行事業</strong><br />企業の営業活動を代行し、売り上げと成約率の上昇をサポートします。</p>
            </div>
            <div className="item">
              <img src="/business4.jpg" alt="事業4" />
              <p><strong>コンサルティング事業</strong><br />主にECサイトの運営、管理についてのコンサルティングを行っております。</p>
            </div>
          </div>
        </section>
        <section id="news">
          <h2>NEWS</h2>
          <h3 className="section-title">お知らせ</h3>
          <ul>
            <li>
              <p>お知らせはここに掲載します。</p>
            </li>
          </ul>
        </section>
        <section id="contact">
          <h2>CONTACT</h2>
          <h3 className="section-title">お問い合わせ</h3>
          <div className="contact-content">
            <div className="contact-form">
              <iframe
                title="お問い合わせフォーム"
                src="https://docs.google.com/forms/d/e/1FAIpQLSd2Da7Fv1irdaxQUYHSvnNybjYetiLvbsEgpcQgGMaPTO9p3Q/viewform?embedded=true"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0">
                読み込んでいます…
              </iframe>
            </div>
            <div className="contact-line">
              <p>LINEでもお問い合わせいただけます</p>
              <img src="/line-qr.png" alt="LINE QRコード" />
            </div>
          </div>
        </section>

        <section id="company-overview">
          <h2>COMPANY</h2>
          <h3 className="section-title">会社概要</h3>
          <table>
            <tbody>
              <tr>
                <th>商号</th>
                <td>株式会社テイルズ（Tales Inc.）</td>
              </tr>
              <tr>
                <th>所在地</th>
                <td>
                  【東京本社】〒113-0023 東京都文京区向丘1-1-17 タカサキヤビル9F<br />
                  【大阪支社】〒540-0026 大阪市中央区内本町1-2-2 有恒ビル401号室
                </td>
              </tr>
              <tr>
                <th>代表</th>
                <td>渡辺聖司</td>
              </tr>
              <tr>
                <th>E-mail</th>
                <td>seiji.w@talesjp.info</td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td>09037690402</td>
              </tr>
              <tr>
                <th>創業</th>
                <td>2024年5月21日</td>
              </tr>
              <tr>
                <th>資本金</th>
                <td>110万円</td>
              </tr>
              <tr>
                <th>事業内容</th>
                <td>ブランドリユース業・輸出業・卸小売業・営業代行事業・コンサルティング事業</td>
              </tr>
              <tr>
                <th>古物商許可</th>
                <td>第 305472515171 号</td>
              </tr>
            </tbody>
          </table>
          <iframe
            className='map-iframe'
            title="会社所在地の地図"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.406304792425!2d139.75572941187565!3d35.71622482793562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188c3392db43b9%3A0xdb8ed51612e32566!2z44CSMTEzLTAwMjMg5p2x5Lqs6YO95paH5Lqs5Yy65ZCR5LiY77yR5LiB55uu77yR4oiS77yR77yXIOOCv-OCq-OCteOCreODpOODk-ODqw!5e0!3m2!1sja!2sjp!4v1718561260725!5m2!1sja!2sjp"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </section>
      </main>

      <footer className="App-footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/TALES.png" alt="ロゴ" />
            <p>Tales Inc.</p>
          </div>
          <div className="footer-info">
            <p>〒113-0023 東京都文京区向丘1-1-17 タカサキヤビル9F</p>
            <p>E-mail: seiji.w@talesjp.info</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Tales Inc. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
